import React from "react";
import { Link } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faRss, faSquare } from "@fortawesome/free-solid-svg-icons";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="columns">
          <div className="column">
            <Link to="/">
              <img src="/img/dripstat-logo-black.png" alt="dripstat" />
            </Link>
          </div>
          <div className="column">
            <h5>About</h5>
            <ul>
              <li>
                <Link to="/about">Company</Link>
              </li>
              <li>
                <a href="https://changelog.dripstat.com/">Changelog</a>
              </li>
              <li>
                <a href="https://docs.dripstat.com">Documentation</a>
              </li>
            </ul>
          </div>
          <div className="column">
            <h5>Products</h5>
            <ul>
              <li>
                <Link to="/products/apm/">DripStat APM</Link>
              </li>
              <li>
                <Link to="/products/infra/">DripStat Infra</Link>
              </li>
              <li>
                <Link to="/products/kubernetes/">DripStat Kubernetes</Link>
              </li>
            </ul>
          </div>
          <div className="column">
            <h5>Follow Us</h5>
            <ul>
              <li>
                <FontAwesomeIcon icon={faRss} style={{ color: "#EB5629" }} /> <a href="https://blog.dripstat.com/">Blog</a>
              </li>
              <li>
                <FontAwesomeIcon icon={faTwitter} style={{ color: "#279FF2" }} /> <a href="https://twitter.com/dripstat/">Twitter</a>
              </li>
              <li>
                <FontAwesomeIcon icon={faSquare} style={{ color: "#7eb63d" }} /> <a href="https://status.dripstat.com/">Status</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="columns">
          <div className="column column is-2 is-offset-10 tosRow has-text-right">
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
